import { useEffect, useState, useRef, useCallback } from "react";
import PointKeypad from "../PointKeypad";
import { Button, RemoveTab } from "omoplay";
import {
    getConfig,
    getEarnRate,
    getEntryPointList, getPointList,
    getUserPoint,
    notificationStream,
    savePoint,
    usingPoint
} from "../../api/point/point.api";

// [추가] 내역 아이콘
const HistoryIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
    </svg>
);

// [추가] 닫기 아이콘
const CloseIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
    </svg>
);

const PointViewPage = () => {
    const [selectedEntryPoint, setSelectedEntryPoint] = useState()
    const [entryPoints, setEntryPoints] = useState([])
    const [numbers, setNumbers] = useState("")
    // "010" 프리필 — 종전에는 `NumberInput` 의 `initNumber` 가 마운트 시 밀어넣던 값이다.
    // 키패드를 무상태(`PointKeypad`)로 바꿨으므로 페이지가 직접 들고 있어야 한다.
    const [phoneNumber, setPhoneNumber] = useState("010")
    const [confirmPhoneNumber, setConfirmPhoneNumber] = useState(false)
    const [userPoint, setUserPoint] = useState(0)
    const [isUsing, setIsUsing] = useState(false)
    const [isRateType, setIsRateType] = useState(false)
    const [staticPoint, setStaticPoint] = useState(0)
    const [minPoint, setMinPoint] = useState(1000)
    /*
      **채널 기본** 적립율(%)과 적립 상한 — '적립 예정 포인트' 계산의 기본값·상한이다 (2026-08-26 추가).
      🔴 계산은 반드시 백엔드와 같은 식이어야 한다 (`PointController.savePoint`):
         floor(결제금액 × 적용적립율 / 100) 을 구한 뒤 `maxPoint` 가 0 이 아니면 그 값으로 상한.
      🔧 **정정(2026-08-27)** — 종전 주석은 "VIP 등급별 적립율은 이 경로에 관여하지 않으므로
         채널 기본율로 계산해도 값이 맞는다" 였다. **이제 아니다.** 서버가 `resolveEarnRate` 로
         등급을 직접 판정해 적립하도록 바뀌었으므로, 실제 적용율은 아래 `appliedRate` 다.
         여기 `rate` 는 (a) 설정 배지에 보여줄 **채널 설정값** (b) `appliedRate` 조회 실패 시 폴백.
    */
    const [rate, setRate] = useState(null)
    const [maxPoint, setMaxPoint] = useState(null)
    /*
      이 고객에게 **적용될** 적립율과 등급 (2026-08-27 추가).

      🔴 `rate`(위)는 **채널 기본 적립율**이고, 등급 기능이 켜진 채널에서는 실제 적용율이 다르다.
         서버가 `resolveEarnRate` 로 등급을 직접 판정하도록 바꿨으므로(백엔드 변경), 화면의
         '적립 예정' 도 그 값을 받아 써야 실제 적립값과 같아진다.
      🔧 조회 실패 시에는 `null` 로 남고 계산이 채널 기본율로 되돌아간다(값을 안 보여주는 것보다
         근사치라도 보여주는 편이 낫다). 등급 고객이면 그때만 실제보다 낮게 보인다.
    */
    const [appliedRate, setAppliedRate] = useState(null)
    const [appliedGrade, setAppliedGrade] = useState(null)
    // 설정 로드 완료 여부 — 로드 전에는 `rate == null` 이 '적립율 미설정' 과 구분되지 않는다.
    const [configLoaded, setConfigLoaded] = useState(false)
    // '포인트 직접 입력'(override) 켜기 전 확인 팝업
    const [showOverrideConfirm, setShowOverrideConfirm] = useState(false)
    const [notifications, setNotifications] = useState([])

    // 연결 상태 관리 (true: 연결됨, false: 끊김)
    const [isConnectionAlive, setIsConnectionAlive] = useState(true);
    const eventSourceRef = useRef(null);

    // [추가] 내역 보기 상태 및 데이터
    const [isHistoryView, setIsHistoryView] = useState(false);
    const [historyList, setHistoryList] = useState([]);
    // 내역 조회 실패 사유. null 이면 정상(비어 있으면 정말 이력이 없는 것이다).
    const [historyError, setHistoryError] = useState(null);

    // 키패드가 조작하는 대상 — 확인 전 = 전화번호, 확인 후 = 적립/사용 금액.
    // (종전에는 `NumberInput` 내부 state + `key` 리마운트로 갈랐다)
    const keypadValue = confirmPhoneNumber ? numbers : phoneNumber
    const setKeypadValue = confirmPhoneNumber ? setNumbers : setPhoneNumber

    const formatPhone = (raw) => {
        const digits = raw.replace(/\D/g, "").slice(0, 11);
        const len = digits.length;

        if (len < 4) return digits;
        if (len < 8) return `${digits.slice(0, 3)}-${digits.slice(3)}`;

        const isTen = len === 10;
        const midEnd = isTen ? 6 : 7;

        return `${digits.slice(0, 3)}-${digits.slice(3, midEnd)}-${digits.slice(midEnd)}`;
    };

    useEffect(() => {
        getEntryPointList().then(({ data }) => {
            setEntryPoints(data)
        })
        getConfig().then(({ data }) => {
            setIsRateType(data.rate != null)
            setStaticPoint(data.staticPoint)
            setMinPoint(data.minPoint)
            // `rate` 는 응답에서 숫자/문자열 어느 쪽으로도 올 수 있어 명시 변환한다(`Number(null)` 은 0 이라 널체크 먼저).
            setRate(data.rate != null ? Number(data.rate) : null)
            setMaxPoint(data.maxPoint != null ? Number(data.maxPoint) : null)
            setConfigLoaded(true)
        })
    }, []);

    /*
      포인트 이용 내역 불러오기.

      🔴 **반드시 `formatPhone(phoneNumber)` 로 보내야 한다** (2026-08-27 버그 수정).
         종전에는 `phoneNumber` 를 날것으로 보내서 **대기열 '선택 하기' 로 들어온 경우에만
         내역이 비어 있었다.** 원인 =
         ① 서버가 SSE 알림을 **괄호로 감싸 보낸다** — `pointNotificationService.sendNotification(uuid, "(${phoneNumber})")`
            (`PointController.kt` `/point/customer/request`)
         ② 대기열의 '선택 하기' 가 그 문자열을 `setPhoneNumber(notification)` 로 **그대로** 담는다
            → `phoneNumber === "(010-1234-5678)"`
         ③ 서버 `String.toHyphenatedPhoneNumber()`(`libs/Utils.kt:255`)는
            `(\d{3})(\d{3,4})(\d{4})` **연속 숫자**만 하이픈으로 바꾼다. 괄호·하이픈이 섞이면
            매칭이 안 되어 **입력 문자열이 그대로 통과**하고, `point_history.phone_number` 의
            정규형(`010-1234-5678`)과 `eq()` 가 어긋나 결과가 0건이 된다.
         번호를 직접 입력한 경로는 `"01012345678"`(연속 숫자)이라 ③에서 정규화되어 우연히 맞았다.

      🔧 `formatPhone` 은 숫자만 남기고 다시 하이픈을 넣으므로 **두 경로 모두** 정규형이 된다.
         이 파일의 다른 API 호출(`getUserPoint`·`savePoint`·`usingPoint`)은 전부 이미
         `formatPhone(...)` 을 거치고 있었다 — **이 한 곳만 빠져 있었다.**
      ⚠️ `phoneNumber` 자체를 정규화하지는 않는다. 적립 성공 후
         `notifications.filter(nt => nt !== phoneNumber)` 가 **날것 그대로 비교**해 대기열에서
         해당 항목을 지우기 때문이다(괄호를 벗기면 그 삭제가 동작하지 않는다).

      🔧 **오류를 삼키지 않는다** (2026-08-27 추가). 종전에는 `.catch` 가 없어 서버 오류·네트워크
         끊김도 화면에는 '내역이 없습니다' 로 똑같이 보였다. 위 ①~③ 버그의 진단이 늦어진 이유가
         바로 이것이다 — 조회가 **실패한 것과 정말 비어 있는 것**을 구분할 수 없었다.
    */
    const handleOpenHistory = () => {
        setIsHistoryView(true);
        setHistoryError(null);
        setHistoryList([]);
        getPointList(formatPhone(phoneNumber), false)
            .then(({ data }) => {
                setHistoryList(data ?? [])
            })
            .catch((err) => {
                console.error("[point] 이용 내역 조회 실패", err);
                setHistoryError("내역을 불러오지 못했습니다. 다시 시도해주세요.");
            })
    };

    // -----------------------------------------------------------
    // [핵심] SSE 연결 및 재연결 로직 (connectSSE)
    // -----------------------------------------------------------
    const connectSSE = useCallback(() => {
        if (!selectedEntryPoint) return;

        // 이미 연결된 상태라면 중복 연결 방지
        if (eventSourceRef.current?.readyState === 1) {
            console.log('[SSE] 이미 연결되어 있습니다.');
            return;
        }

        // 기존 연결 정리
        if (eventSourceRef.current) {
            eventSourceRef.current.close();
        }

        setIsConnectionAlive(true); // 시도 중에는 살아있는 것으로 간주 (UI 깜빡임 방지)
        console.log('[SSE] 연결 시도...');

        const es = notificationStream(selectedEntryPoint.id);

        es.onopen = () => {
            console.log('[SSE] 연결 성공 (Open/Reconnected)');
            // 빨간불 -> 초록불로 변경되는 핵심 지점
            setIsConnectionAlive(true);
        };

        es.addEventListener('notification', (e) => {
            const data = e.data;
            console.log('[SSE] 데이터 수신:', data);
            setNotifications((prev) => [...new Set([...prev, data])]);
            setIsConnectionAlive(true);
        });

        es.onmessage = (event) => {
            // Heartbeat(Ping) 수신 시 연결 상태 갱신
            console.log('[SSE] Heartbeat or Message:', event.data);
            setIsConnectionAlive(true);
        };

        es.onerror = (err) => {
            console.error('[SSE] 에러 발생:', err);
            // readyState: 0(CONNECTING), 1(OPEN), 2(CLOSED)
            if (es.readyState === 0 || es.readyState === 2) {
                setIsConnectionAlive(false); // 연결이 끊김 -> 재연결 버튼 노출
            }
        };

        eventSourceRef.current = es;
    }, [selectedEntryPoint]);

    useEffect(() => {
        if (selectedEntryPoint) {
            connectSSE();

            const handleVisibilityChange = () => {
                if (document.visibilityState === 'visible') {
                    console.log('[SSE] 탭 활성화 감지. 연결 상태 점검...');
                    const readyState = eventSourceRef.current?.readyState;

                    // 연결이 끊겨있거나(2), 객체가 없으면 즉시 재연결
                    if (!eventSourceRef.current || readyState === 2) {
                        console.log('[SSE] 연결 끊김 확인. 즉시 재연결 시도.');
                        connectSSE();
                    } else if (readyState === 1) {
                        setIsConnectionAlive(true);
                    }
                }
            };

            document.addEventListener('visibilitychange', handleVisibilityChange);

            return () => {
                document.removeEventListener('visibilitychange', handleVisibilityChange);
                if (eventSourceRef.current) {
                    eventSourceRef.current.close();
                }
            };
        }
    }, [selectedEntryPoint, connectSSE]);


    /*
      상단 표시 영역의 글자 크기는 전부 `dvh` `clamp` 로 묶는다 (2026-08-26 개편).

      종전에는 `text-3xl`/`text-6xl` 같은 고정 크기였고 상단 영역이 `h-1/3`(오른쪽 패널의 33%)
      **고정 비율**이었다. 그래서 세로가 짧은 태블릿(16:9·19:9 가로)에서
      ① 번호가 폭을 넘어 **두 줄로 접히고** ② 그 두 줄이 33% 를 넘겨 넘치면서
      ③ 아래 키패드 몫을 잠식했다.
      지금은 상단이 `flex-none` + 내용 높이이고, 글자가 화면 높이에 비례해 줄어들며
      번호는 `whitespace-nowrap` 으로 **두 줄이 되는 경우 자체를 없앴다.**
    */
    const STATUS_TEXT = "text-[clamp(0.9375rem,2.8dvh,1.5rem)]";
    // 🔴 `whitespace-nowrap` + `tracking` 축소 = 낮은 해상도에서 번호가 두 줄로 접히던 문제의 직접 해결.
    //    `tracking-widest`(0.1em) 는 13자에서 폭을 1.3자만큼 더 잡아먹어 접힘을 앞당겼다.
    const BIG_NUMBER = "font-black text-gray-900 whitespace-nowrap text-[clamp(1.5rem,7dvh,3.75rem)]";

    /*
      채널 설정이 '고정 포인트'(적립율 미설정 = `config.rate == null`) 인지 (2026-08-26 사용자 확인).

      🔴 그 채널에서는 **'결제 금액(%) 적립' 이 애초에 성립하지 않는다** —
         서버 `PointController.savePoint` 의 첫 분기가 `defaultRate == null` 이면
         입력값을 보지 않고 `staticPoint` 를 적립해 버린다. 금액을 넣어도 반영되지 않는다.
      ⇒ 토글을 노출하지 않고(선택 불가), 안내도 '입력하세요' 가 아니라 '적립됩니다' 로 바꾼다.
         `configLoaded` 를 함께 보는 이유 = 설정 로드 전에는 `rate` 가 null 이라
         토글이 잠깐 사라졌다 나타나는 깜빡임이 생긴다.
    */
    const isStaticOnly = configLoaded && rate == null;

    /*
      '고정 포인트' 채널의 적립 금액은 **조작자가 바꿀 수 없다** (2026-08-26 사용자 결정).

      '고정 적립' 의 뜻은 "포인트를 손으로 넣겠다" 가 아니라 **"설정에서 정한 값을 지급한다"** 다.
      그래서 그 채널에서는
        ① 확인 단계에 들어갈 때 `numbers` 를 `staticPoint` 로 **미리 채우고**
        ② 키패드를 **비활성**으로 만들어 못 고치게 한다.
      ⇒ 화면 표시(`Number(numbers)`)·서버 전송(`point`)·비활성 판정이 전부 같은 값을 쓰게 되어
        분기를 따로 두지 않아도 된다.
      포인트 '사용'(`isUsing`)은 사용할 포인트를 입력해야 하므로 비활성 대상이 아니다.
    */
    const amountLocked = confirmPhoneNumber && isStaticOnly && !isUsing;

    // 확인 단계 진입 시 금액 입력값. 고정 포인트 채널은 설정값을 미리 채운다.
    const initialAmount = () => (isStaticOnly ? String(staticPoint ?? "") : "");

    /*
      채널 설정 모드로 되돌린다(= '포인트 직접 입력' override 해제).

      🔴 **고객이 바뀌는 지점마다 호출해야 한다.** override 는 "특수한 상황에만" 쓰는 기능인데
         상태로 남아 있으면 **다음 고객까지 조용히 직접 입력 모드로 적립**된다.
         호출 지점 = '이전 단계' / '적립 완료' 성공 / '사용 완료' 성공 (아래 3곳).
    */
    const resetToConfiguredMode = () => {
        setIsRateType(rate != null);
        // 적용 적립율·등급은 고객마다 다르다 → 다음 고객에게 이전 값이 잠깐 보이지 않게 비운다.
        setAppliedRate(null);
        setAppliedGrade(null);
    };

    /*
      확인 단계로 넘어갈 때 고객 정보를 읽는다 — 보유 포인트 + **적용될 적립율/등급**.

      🔧 종전에는 `getUserPoint` 만 불렀다. 적립율을 서버가 정하도록 바꾼 뒤로는
         적용 적립율도 함께 받아야 '적립 예정' 표시가 실제 적립값과 같아진다.
      🔧 적립율 조회가 실패해도 **화면은 계속 쓸 수 있어야 한다** → 값을 비우고 채널 기본율로
         되돌아간다(그때는 등급 고객만 실제보다 낮게 보인다).
    */
    const loadCustomer = (formattedPhone) => {
        getUserPoint(formattedPhone).then(({ data }) => setUserPoint(data));
        getEarnRate(formattedPhone)
            .then(({ data }) => {
                setAppliedRate(data?.rate != null ? Number(data.rate) : null);
                setAppliedGrade(data?.grade ?? null);
            })
            .catch(() => {
                setAppliedRate(null);
                setAppliedGrade(null);
            });
    };

    /*
      '결제 금액(%) 적립' 의 **적립 예정 포인트** (2026-08-26 추가 / 2026-08-26 정밀도 보정).

      🔧 **백엔드와 비트 단위로 같은 값**을 내기 위해 Kotlin 의 `Float`(32bit) 연산을 그대로 재현한다.
         백엔드(`PointController.savePoint`):
             ((sales.toInt()) * ((rate ?: defaultRate.toFloat()) / 100)).toInt()
         `defaultRate` 는 BigDecimal → `toFloat()` = 32bit, 이후 계산도 전부 Float 이다.
         JS 는 모든 산술이 double(64bit) 이므로 **연산마다 `Math.fround` 로 32bit 로 접어준다.**
         `Math.fround(x)` = x 를 가장 가까운 32bit float 로 반올림.

      ✅ 이렇게 하면 결과가 정확히 같다 — 곱셈·나눗셈은 중간 정밀도가 `2p+2`(= 24×2+2 = 50) bit
         이상이면 **이중 반올림이 무해**하다는 성질이 있고 double 은 53bit 다.
         즉 "double 로 계산 후 float 로 반올림" = "float 로 직접 계산".
      🔧 `Float.toInt()` 은 내림이 아니라 **0 방향 절단**이라 `Math.trunc` 를 쓴다
         (양수만 다루므로 `Math.floor` 와 결과는 같지만 의미를 맞춰둔다).

      이 화면은 `rate` 를 서버로 보내지 않으므로 **채널 기본 `rate`** 가 적용된다
      (VIP 등급별 적립율은 이 경로에 관여하지 않는다).
    */
    const earnEstimate = (() => {
        if (!confirmPhoneNumber || isUsing || !isRateType || rate == null) return null;
        // 🔧 금액을 아직 안 넣었어도(0원) 설정된 적립율은 보여준다(사용자 요청) → 빈 값은 0 으로 본다.
        const sales = numbers ? Number(numbers) : 0;
        if (!Number.isFinite(sales) || sales < 0) return null;

        /*
          🔴 **서버가 적용할 적립율**을 쓴다 (2026-08-27). `appliedRate` = `/point/user/earn-rate`
             응답(등급이 붙으면 등급 적립율). 조회 실패 시에만 채널 기본율 `rate` 로 폴백한다.
             종전에는 항상 채널 기본율로 계산해서, 등급 기능을 켜면 표시와 실제 적립이 어긋났다.
        */
        const effectiveRate = appliedRate ?? rate;
        const rateF = Math.fround(effectiveRate);                 // BigDecimal.toFloat()
        const perUnitF = Math.fround(rateF / 100);                 // Float / Int -> Float
        // 🔴 `Int * Float` 은 **Int 를 먼저 Float 으로 넓힌 뒤** 곱한다.
        //    이 한 단계를 빼먹으면 결제금액이 2^24(16,777,216) 를 넘는 순간 값이 어긋난다
        //    (예: rate 0.5% / 99,999,999원 → 서버 500,000P vs 누락 시 499,999P. JVM 대조로 확인).
        const salesF = Math.fround(sales);                         // Int -> Float 승격
        const productF = Math.fround(salesF * perUnitF);           // Float * Float -> Float
        const raw = Math.trunc(productF);                          // Float.toInt() = 0 방향 절단
        const capped = (maxPoint != null && maxPoint !== 0) ? Math.min(raw, maxPoint) : raw;
        return {
            point: capped,
            isCapped: capped < raw,
            rate: effectiveRate,
            // 등급이 붙어 채널 기본율과 달라졌는지 — 화면에 등급명을 함께 보여줄 근거
            gradeLabel: (appliedGrade && appliedGrade !== "일반") ? appliedGrade : null,
        };
    })();

    /*
      주 버튼('포인트 적립'/'적립 완료'/'사용 완료') 비활성 조건. 종전 그대로다.

      🔧 고정 포인트 채널은 `initialAmount()` 로 `numbers` 가 이미 `staticPoint` 로 채워지므로
         `numbers.length === 0` 예외를 따로 둘 필요가 없다. `staticPoint` 가 비어 있는
         (= 설정이 잘못된) 채널에서는 버튼이 비활성으로 남는데, 그게 맞다 — 적립할 값이 없다.
    */
    const primaryDisabled =
        phoneNumber.length < 9
        || (isUsing && (minPoint > userPoint || (userPoint < Number(numbers))))
        || (confirmPhoneNumber && numbers.length === 0);

    /*
      '포인트 직접 입력'(override) 이 켜져 있는가 (2026-08-26 재정의).

      `isRateType === false` 가 곧 override 다 — 채널 설정은 적립율인데 금액 대신 포인트를 직접 넣는다
      (`savePoint` 가 `sales` 대신 `point` 를 받아 `point?.toInt()` 분기를 탄다).
      고정 포인트 채널(`isStaticOnly`)에는 override 가 없다 — §아래 `renderOverrideButton` 주석 참고.
    */
    const isManualOverride = configLoaded && !isStaticOnly && !isRateType;

    // 현재 채널의 적립 설정을 사람이 읽는 문장으로. 확인 팝업과 설정 배지가 함께 쓴다.
    const configModeLabel = isStaticOnly
        ? `${Number(staticPoint ?? 0).toLocaleString()}P 고정 적립`
        : (rate != null ? `결제 금액의 ${rate}% 적립` : "미설정");

    // 안내 문구 — 무엇을 해야 하는지를 그대로 적는다.
    const statusMessage = () => {
        if (!confirmPhoneNumber) return { text: "번호를 입력해주세요", tone: "text-gray-800" };
        if (isUsing) {
            if (minPoint > userPoint) return { text: `포인트 부족 (최소 ${minPoint.toLocaleString()}P)`, tone: "text-red-500" };
            if (userPoint < Number(numbers)) return { text: "보유 포인트 부족", tone: "text-red-500" };
            return { text: "사용할 포인트를 입력하세요", tone: "text-gray-800" };
        }
        if (isStaticOnly) {
            // 설정값은 아래 큰 숫자와 설정 배지가 보여주므로, 문구는 '무엇을 하면 되는지' 만 적는다.
            return { text: "'적립 완료'를 누르면 적립됩니다", tone: "text-blue-600" };
        }
        // 🔴 override 중에는 **붉은색으로 강조**한다(사용자 요청). 평소 상태와 확실히 구분되어야 한다.
        return isManualOverride
            ? { text: "적립할 포인트를 입력하세요", tone: "text-red-600" }
            : { text: "결제 금액을 입력하세요", tone: "text-blue-600" };
    };

    /*
      [설정 배지] 현재 적립 설정을 **읽기 전용**으로 알린다 (2026-08-26 사용자 요청).

      기본 상태의 화면은 "지금 적립 설정이 이렇게 되어 있다" 를 분명히 말하는 것으로 끝나야 한다.
      그래서 이건 버튼이 아니다 — 회색 알약이고 누를 수 없다.
      override 가 켜져 있으면 취소선 + '무시 중' 을 붙여, 설정을 벗어난 상태임을 드러낸다.
    */
    const renderConfigBadge = () => (
        <div className={`rounded-full font-bold whitespace-nowrap px-[clamp(0.5rem,1.6dvh,0.875rem)] py-[clamp(0.0625rem,0.4dvh,0.25rem)] text-[clamp(0.625rem,1.7dvh,0.8125rem)] ${
            isManualOverride ? "bg-gray-100 text-gray-400 line-through" : "bg-gray-100 text-gray-600"
        }`}>
            현재 적립 설정 · {configModeLabel}
            {isManualOverride && <span className="ml-1 no-underline">(무시 중)</span>}
        </div>
    );

    /*
      [override 버튼] '포인트 직접 입력' — **별도의 특별 기능**으로 보여야 한다 (2026-08-26 사용자 요청).

      🔧 종전에는 두 모드가 같은 크기의 세그먼트 토글로 나란히 있어서 **휙휙 바꿔도 되는 것처럼** 보였다.
         지금은 ⓐ 설정 배지(읽기 전용)와 분리된 **단독 버튼**이고 ⓑ 평소엔 얇은 테두리(amber)로 눌러야
         알아채는 정도이며 ⓒ 켜는 순간 **확인 팝업**을 통과해야 하고 ⓓ 켜진 뒤에는 붉은색으로 남는다.
      🔧 끄기는 팝업 없이 같은 버튼을 다시 누르면 된다(사용자 요청) → 원래 설정 모드로 복귀.
      🔴 고정 포인트 채널에는 이 버튼을 두지 않는다 — 서버가 `defaultRate == null` 분기에서
         **입력값을 버리고 `staticPoint` 를 적립**하므로 override 가 애초에 동작하지 않는다.
    */
    const renderOverrideButton = () => {
        const base = "rounded-full font-bold transition-all whitespace-nowrap border px-[clamp(0.5rem,1.6dvh,0.875rem)] py-[clamp(0.125rem,0.6dvh,0.3125rem)] text-[clamp(0.625rem,1.7dvh,0.8125rem)]";
        if (isManualOverride) {
            return (
                <button
                    className={`${base} bg-red-600 border-red-600 text-white`}
                    onClick={() => {
                        // 끄기 = 원래 설정 모드로 복귀. 확인 팝업 없음.
                        setIsRateType(true);
                        setNumbers("");
                    }}
                >
                    ✏️ 직접 입력 중 · 해제
                </button>
            );
        }
        return (
            <button
                className={`${base} bg-white border-amber-300 text-amber-600 hover:bg-amber-50`}
                onClick={() => setShowOverrideConfirm(true)}
            >
                ✏️ 포인트 직접 입력
            </button>
        );
    };

    /*
      [확인 팝업] override 를 켤 때 한 번 막는다 (2026-08-26 사용자 요청).

      레이아웃은 이 저장소 표준 처방을 따른다 — 오버레이가 스크롤 컨테이너(`overflow-y-auto`),
      카드는 `m-auto`. flex 중앙정렬은 내용이 화면보다 길 때 위쪽이 잘리고 스크롤로도 못 닿는다
      (`001_rootcause_and_fix.md` / `pages/JoinPage.js` 주석).
    */
    const renderOverrideConfirm = () => (
        <div className="fixed inset-0 z-50 flex overflow-y-auto bg-black/60 backdrop-blur-sm p-4">
            <div className="bg-white rounded-3xl shadow-2xl w-full max-w-lg m-auto p-[clamp(1rem,4dvh,2.5rem)]">
                <h3 className="font-black text-red-600 text-center text-[clamp(1.0625rem,3.2dvh,1.5rem)] mb-[clamp(0.625rem,2.5dvh,1.5rem)]">
                    포인트 직접 입력 상태로 변경됩니다!!
                </h3>
                <div className="flex flex-col gap-[clamp(0.375rem,1.5dvh,0.75rem)] text-gray-700 text-[clamp(0.8125rem,2.2dvh,1rem)]">
                    <div>현재 설정된 적립방식은 <b className="text-blue-600">{configModeLabel}</b> 입니다.</div>
                    <div className="font-bold text-red-600">포인트 직접 입력 기능은 특수한 상황에만 사용하세요.</div>
                    <div>결제한 금액이 아니라 <b>적립할 포인트</b>를 입력합니다.</div>
                </div>
                <div className="flex gap-2 mt-[clamp(0.875rem,3.5dvh,2rem)] h-[clamp(2.75rem,8dvh,3.5rem)]">
                    <button
                        className="basis-1/3 shrink-0 bg-white border-2 border-gray-200 text-gray-600 font-bold rounded-xl hover:bg-gray-50 text-[clamp(0.8125rem,2.4dvh,1.125rem)]"
                        onClick={() => setShowOverrideConfirm(false)}
                    >
                        취소
                    </button>
                    <button
                        className="flex-1 min-w-0 bg-red-600 hover:bg-red-700 text-white font-bold rounded-xl shadow-lg text-[clamp(0.875rem,2.8dvh,1.25rem)]"
                        onClick={() => {
                            setIsRateType(false);   // override ON
                            setNumbers("");         // 금액 → 포인트로 의미가 바뀌므로 초기화
                            setShowOverrideConfirm(false);
                        }}
                    >
                        확인 했습니다
                    </button>
                </div>
            </div>
        </div>
    );

    /*
      [묶음 1] 입력 묶음 = "무엇을 입력하라" + "지금 입력된 값" (+ 적립 예정 포인트)

      사용자 요청(2026-08-26): 안내 문구와 입력값은 **한 묶음**, 전화번호·보유포인트·내역은 **다른 묶음**.
      종전에는 안내문이 위줄, 전화번호·금액·보유포인트·내역이 아랫줄에 한꺼번에 있어
      **문구와 그 문구가 가리키는 입력값이 서로 다른 묶음에 흩어져 있었다.**
    */
    const renderInputGroup = () => {
        const msg = statusMessage();
        return (
            <div className="flex flex-col items-center justify-center gap-[clamp(0.125rem,0.8dvh,0.5rem)]">
                {/* 안내 문구 + 적립 방식 토글 — `md:flex-row` 로 가로 배치(세로가 짧은 태블릿 대응) */}
                <div className="flex flex-col md:flex-row md:items-center items-center justify-center flex-wrap gap-x-2 gap-y-1">
                    <div className={`font-bold ${msg.tone} ${STATUS_TEXT}`}>{msg.text}</div>
                    {/* 적립(=사용 아님) 단계에서는 항상 현재 설정을 알린다 */}
                    {(!isUsing && confirmPhoneNumber && configLoaded) && renderConfigBadge()}
                    {/* override 는 적립율 채널에서만. 설정 배지와 분리된 단독 버튼이다 */}
                    {(!isUsing && confirmPhoneNumber && configLoaded && !isStaticOnly) && renderOverrideButton()}
                </div>

                {/* 입력값 */}
                {!confirmPhoneNumber ? (
                    <div className={`${BIG_NUMBER} tracking-[0.06em] ${!phoneNumber ? 'opacity-30' : ''}`}>
                        {phoneNumber ? formatPhone(phoneNumber) : "010-0000-0000"}
                    </div>
                ) : (
                    <div className="flex items-baseline justify-center flex-wrap gap-x-2">
                        <div className={BIG_NUMBER}>
                            {Number(numbers).toLocaleString()}
                            <span className="font-medium text-gray-500 ml-1 text-[clamp(1rem,4.2dvh,2.25rem)]">{(isUsing || !isRateType) ? "P" : "원"}</span>
                        </div>
                        {/* 적립 예정 포인트 — 결제 금액 입력 중에만, 금액 옆에 작게 */}
                        {earnEstimate && (
                            <div className="font-bold text-blue-600 whitespace-nowrap text-[clamp(0.75rem,2.4dvh,1.25rem)]">
                                → {earnEstimate.point.toLocaleString()}P 적립 예정
                                <span className="font-medium text-gray-400 ml-1 text-[clamp(0.625rem,1.7dvh,0.875rem)]">
                                    {/* 🔧 채널 기본율이 아니라 **적용될 적립율**을 적는다.
                                        등급이 붙으면 등급명까지 보여야 왜 다른 값인지 알 수 있다. */}
                                    {earnEstimate.isCapped
                                        ? `(상한 ${maxPoint.toLocaleString()}P)`
                                        : (earnEstimate.gradeLabel
                                            ? `(${earnEstimate.gradeLabel} · ${earnEstimate.rate}%)`
                                            : `(${earnEstimate.rate}%)`)}
                                </span>
                            </div>
                        )}
                        {/* 고정 포인트 채널 — 키패드가 잠겨 있음을 알린다(설정값 자체는 배지가 말한다) */}
                        {amountLocked && (
                            <div className="font-medium text-gray-400 whitespace-nowrap text-[clamp(0.625rem,1.8dvh,0.875rem)]">
                                변경 불가
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    };

    /*
      [묶음 2] 고객 묶음 = 전화번호 + 보유 포인트 + 내역

      🔧 구분선(`border-l`)은 쓰지 않는다 — `md:` 는 화면 폭만 보므로 **줄바꿈이 일어나면 선이 허공에 남는다**
         (실측으로 확인). 대신 묶음 안은 좁은 간격(`gap-2`), 묶음 사이는 넓은 간격(부모의 `gap-x` 최대 2.5rem)
         으로 구분한다 — 어느 배치에서도 깨지지 않는다.
    */
    const renderCustomerGroup = () => {
        if (!confirmPhoneNumber) return null;
        return (
            <div className="flex items-center justify-center flex-wrap gap-2">
                <div className="font-bold text-gray-500 whitespace-nowrap tracking-[0.04em] text-[clamp(0.8125rem,2.6dvh,1.5rem)]">
                    {formatPhone(phoneNumber)}
                </div>
                <div className="bg-blue-50 text-blue-700 rounded-full font-bold whitespace-nowrap px-[clamp(0.5rem,1.6dvh,1rem)] py-[clamp(0.0625rem,0.4dvh,0.25rem)] text-[clamp(0.75rem,2.2dvh,1.125rem)]">
                    보유 포인트: {Number(userPoint).toLocaleString()} P
                </div>
                {/* [추가] 내역 보기 버튼: 높이 UI에 영향을 주지 않도록 옆에 배치 */}
                <button
                    onClick={handleOpenHistory}
                    className="flex items-center gap-1 bg-gray-100 hover:bg-gray-200 active:bg-gray-300 text-gray-600 font-bold rounded-full transition-colors whitespace-nowrap px-[clamp(0.375rem,1.4dvh,0.75rem)] py-[clamp(0.125rem,0.7dvh,0.375rem)] text-[clamp(0.6875rem,1.7dvh,0.875rem)]"
                >
                    <HistoryIcon />
                    <span className="mt-0.5">내역</span>
                </button>
            </div>
        );
    };

    return (
        /* `touch-manipulation` = 이 화면 전체에서 double-tap 확대를 끈다 → 탭 지연(~300ms) 제거.
           키패드는 자기 요소에도 따로 걸어 둔다(리팩터에도 살아남게). 상세 = `components/PointKeypad.js` 주석 */
        <div className="font-sans antialiased text-gray-900 bg-gray-50 h-screen h-[100dvh] w-full overflow-hidden touch-manipulation">
            {!selectedEntryPoint ? (
                // 진입점 선택 모달
                /*
                  진입점이 많으면 아래쪽 진입점을 누를 수 없던 문제 수정 (2026-08-26)

                  종전 = `flex items-center justify-center` + 카드에 높이 제한/스크롤 없음.
                  진입점 7개(3열 × 3행)부터 카드가 1024~1280px 태블릿 높이를 넘고,
                  **flex 중앙정렬은 넘친 만큼을 위/아래로 반씩 밀어낸다.** 오버레이는
                  `overflow: visible` 이라 스크롤 컨테이너가 아니고, 페이지 자체도
                  최상단이 `h-screen overflow-hidden` 이라 스크롤되지 않는다.
                  ⇒ 제목이 위로 잘리고 마지막 행은 아래로 잘린 채 **닿을 방법이 없었다.**
                  (실측 @1280×800: 진입점 9개면 카드 828px / 뷰포트 713px, top=-57.
                   12개면 마지막 3개가 `elementFromPoint` 로도 안 잡힌다 = 클릭 불가.)

                  수정 = ① 오버레이를 스크롤 컨테이너로 만들고(`overflow-y-auto`)
                        ② 카드는 `items-center` 가 아니라 **`m-auto`** 로 중앙정렬한다.
                  auto margin 은 여유가 있을 때만 중앙정렬하고 부족하면 위에서부터 흘러서,
                  넘친 부분이 전부 스크롤 범위 안에 들어온다.
                  같은 처방을 회원가입·아이디/비번찾기 화면에 이미 적용했다 → `pages/JoinPage.js` 주석 참고.
                */
                <div className="fixed inset-0 z-50 flex overflow-y-auto bg-black/60 backdrop-blur-sm p-4">
                    <div className="bg-white rounded-3xl shadow-2xl w-full max-w-4xl m-auto transform transition-all p-[clamp(1rem,3.5dvh,2.5rem)]">
                        <h2 className="font-bold text-center text-gray-800 text-[clamp(1.125rem,3.4dvh,1.875rem)] mb-[clamp(0.75rem,3dvh,2.5rem)]">
                            포인트를 적립할 매장(진입점)을 선택해주세요
                        </h2>
                        {/* 카드 크기를 `dvh` 로 묶어 세로가 짧은 태블릿에서 한 화면에 더 많이 들어오게 한다 */}
                        <div className="grid grid-cols-2 md:grid-cols-3 gap-[clamp(0.5rem,2dvh,1.5rem)]">
                            {entryPoints.map((entryPoint) => (
                                <button
                                    key={entryPoint.id}
                                    className="flex flex-col items-center justify-center bg-white border-2 border-gray-100 rounded-2xl hover:border-blue-500 hover:bg-blue-50 hover:shadow-lg transition-all duration-200 group gap-[clamp(0.375rem,1.5dvh,1rem)] p-[clamp(0.75rem,3dvh,2rem)]"
                                    onClick={() => setSelectedEntryPoint({ name: entryPoint.name, id: entryPoint.id })}
                                >
                                    <div className="relative rounded-full overflow-hidden bg-gray-100 group-hover:scale-105 transition-transform shrink-0 w-[clamp(2.5rem,9dvh,6rem)] h-[clamp(2.5rem,9dvh,6rem)]">
                                        <img className="object-cover w-full h-full" alt={entryPoint.name} src={entryPoint.imageUrl} />
                                    </div>
                                    <span className="font-bold text-gray-700 group-hover:text-blue-700 text-center break-keep text-[clamp(0.875rem,2.2dvh,1.25rem)]">{entryPoint.name}</span>
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            ) : (
                // 메인 화면
                <div className="flex h-full min-h-0">

                    {/*
                      왼쪽 사이드바: 대기열/알림

                      종전 `w-80`(320px 고정)은 1024px 태블릿에서 화면의 **31%** 를 가져가
                      오른쪽 번호 표시 영역의 폭을 좁혔고, 그게 번호가 두 줄로 접히는 원인 중 하나였다.
                      `clamp(11rem, 22vw, 20rem)` = 화면 폭의 22% 를 쓰되 176px~320px 로 묶는다.
                      (1024px → 225px / 1280px → 281px / 1440px 이상 → 320px 유지)
                      `shrink-0` 로 내용물 때문에 더 커지지도, 찌그러지지도 않게 못박는다.
                    */}
                    <div className="shrink-0 w-[clamp(11rem,22vw,20rem)] bg-white border-r border-gray-200 flex flex-col min-h-0 shadow-lg z-10">
                        <div className="flex-none border-b border-gray-100 p-[clamp(0.625rem,2.5dvh,1.5rem)]">
                            <h3 className="font-bold text-gray-800 text-[clamp(0.8125rem,2.2dvh,1.125rem)]">📋 적립 요청 대기열</h3>
                            <div className="flex items-center justify-between gap-1 mt-1">
                                <p className="text-gray-500 truncate text-[clamp(0.6875rem,1.7dvh,0.875rem)]">고객 적립 요청 리스트</p>
                                {/* 연결 상태 표시 */}
                                <span className={`font-bold px-2 py-0.5 rounded-full shrink-0 text-[clamp(0.5625rem,1.4dvh,0.75rem)] ${isConnectionAlive ? 'bg-green-100 text-green-600' : 'bg-red-100 text-red-600'}`}>
                                    {isConnectionAlive ? 'LIVE' : 'DISCONNECTED'}
                                </span>
                            </div>
                        </div>

                        {/* `min-h-0` 없으면 목록이 줄지 못해 아래 '관리자 페이지 이동' 이 화면 밖으로 밀린다 */}
                        <div className="flex-1 min-h-0 overflow-y-auto p-3 space-y-3 bg-gray-50/50">

                            {/* [추가됨] 연결 끊김 시 재연결 버튼 표시 */}
                            {!isConnectionAlive && (
                                <div className="bg-red-50 border border-red-200 p-4 rounded-xl flex flex-col items-center gap-2 mb-4 animate-pulse">
                                    <span className="text-red-600 font-bold text-sm">서버 연결이 끊어졌습니다.</span>
                                    <button
                                        onClick={connectSSE}
                                        className="w-full py-2 bg-red-500 hover:bg-red-600 text-white rounded-lg font-bold text-sm transition-colors shadow-sm"
                                    >
                                        🔄 연결 다시 시도하기
                                    </button>
                                </div>
                            )}

                            {notifications.length === 0 && isConnectionAlive && (
                                <div className="flex flex-col items-center justify-center h-24 text-gray-400">
                                    <span className="text-center text-[clamp(0.6875rem,1.7dvh,0.875rem)]">대기중인 요청이 없습니다</span>
                                </div>
                            )}

                            {notifications.map((notification) => (
                                <div key={notification} className="bg-white rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-all p-3">
                                    <div className="flex items-center justify-between gap-1 mb-2">
                                        <span className="font-bold text-gray-800 truncate text-[clamp(0.8125rem,2.2dvh,1.125rem)]">
                                            {formatPhone(notification)}
                                        </span>
                                        <button
                                            className="text-gray-400 hover:text-red-500 transition-colors shrink-0"
                                            onClick={() => setNotifications(prev => prev.filter(nt => nt !== notification))}
                                        >
                                            <RemoveTab />
                                        </button>
                                    </div>
                                    <Button
                                        variants="secondary"
                                        value="선택 하기"
                                        className="w-full py-2 bg-blue-50 text-blue-600 hover:bg-blue-100 rounded-lg font-semibold text-sm transition-colors"
                                        onClick={() => {
                                            setPhoneNumber(notification)
                                            setConfirmPhoneNumber(true)
                                            setNumbers(initialAmount())   // 리마운트 초기화 대체 + 고정 포인트 채널은 설정값 프리필
                                            loadCustomer(formatPhone(notification))
                                        }}
                                    />
                                </div>
                            ))}
                        </div>
                        {/* `flex-none` = 목록이 길어도 이 영역은 언제나 화면 안에 남는다 */}
                        <div className="flex-none border-t border-gray-200 bg-white p-3">
                            <div className="mb-2 font-bold text-gray-600 truncate text-[clamp(0.6875rem,1.7dvh,0.875rem)]">{selectedEntryPoint.name}</div>
                            <Button
                                variants="default"
                                value="관리자 페이지 이동"
                                className="w-full py-2 bg-gray-100 text-gray-600 hover:bg-gray-200 rounded-lg font-medium transition-colors text-[clamp(0.6875rem,1.7dvh,0.875rem)]"
                                onClick={() => window.location.href = "/point/users"}
                            />
                        </div>
                    </div>

                    {/*
                      오른쪽 메인 컨텐츠 — 높이 배분 우선순위 (2026-08-26 개편)

                      종전 = 상단 표시 영역이 `h-1/3`(패널 높이의 33%) **고정 비율**이었다.
                      세로가 짧아지면 33% 도 같이 줄어드는데 안의 글자는 `text-6xl` 고정이라
                      내용이 영역을 넘쳤고, 아래 `flex-1` 에는 `min-h-0` 이 없어 키패드가
                      내용 높이 아래로 줄지 못해 **버튼이 화면 밖으로 밀렸다.**

                      지금 = ① 상단은 `flex-none` + 내용 높이(글자가 `dvh` 로 줄어든다)
                             ② 키패드가 `flex-1 min-h-0` 로 남는 높이를 전부 가져간다(최우선)
                             ③ 하단 버튼은 `flex-none` + 높이 하한 → 절대 가려지지 않는다
                      `min-w-0` = 사이드바가 좁아졌을 때 이 패널이 그만큼 넓어지게 한다.
                    */}
                    <div className="flex-1 min-w-0 flex flex-col min-h-0 h-full bg-gray-50 relative">
                        {/* 상단 표시 영역도 `md:flex-row` — 세로로 쌓인 두 블록을 나란히 두면
                            그 차이가 그대로 키패드 높이가 된다(16:9 에서 체감이 가장 크다). */}
                        <div className="flex-none flex flex-col md:flex-row items-center justify-center flex-wrap bg-white shadow-sm z-0 px-4 py-[clamp(0.5rem,2.5dvh,2rem)] gap-x-[clamp(0.75rem,3vw,2.5rem)] gap-y-[clamp(0.375rem,2dvh,1.5rem)]">
                            <div>{renderInputGroup()}</div>
                            {renderCustomerGroup()}
                        </div>

                        {/* `max-w-xl`(576px) = 종횡비로 역산되는 키패드 폭(≈540px)에 맞춘 값이다.
                            종전 `max-w-3xl`(768px) 이면 버튼만 넓어져 키패드와 폭이 어긋나 보였다. */}
                        <div className="flex-1 min-h-0 flex flex-col items-center max-w-xl mx-auto w-full px-4 pb-[clamp(0.5rem,2dvh,1.5rem)] pt-[clamp(0.5rem,2dvh,1.5rem)]">
                            <div className="w-full flex-1 min-h-0 mb-[clamp(0.5rem,2dvh,1.5rem)] relative">
                                {isHistoryView ? (
                                    // [추가] 1. 내역 보기 화면 (숫자 입력란 대체)
                                    <div className="absolute inset-0 flex flex-col bg-white rounded-2xl border border-gray-200 overflow-hidden animate-fade-in z-20">
                                        <div className="flex-none flex items-center justify-between px-4 py-2 border-b border-gray-100 bg-gray-50">
                                            <h3 className="font-bold text-gray-800 flex items-center gap-2 text-[clamp(0.8125rem,2.2dvh,1.125rem)]">
                                                📜 포인트 이용 내역
                                            </h3>
                                            <button
                                                onClick={() => setIsHistoryView(false)}
                                                className="p-1.5 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-colors shrink-0"
                                            >
                                                <CloseIcon />
                                            </button>
                                        </div>
                                        <div className="flex-1 min-h-0 overflow-y-auto p-2">
                                            {/* 🔧 조회 실패와 '정말 이력이 없음' 을 구분해 보여준다 */}
                                            {historyError ? (
                                                <div className="h-full flex flex-col items-center justify-center gap-2 text-red-500">
                                                    <div className="text-center text-sm font-bold">{historyError}</div>
                                                    <button
                                                        type="button"
                                                        className="px-3 py-1.5 bg-red-50 hover:bg-red-100 text-red-600 rounded-lg font-bold text-sm touch-manipulation"
                                                        onClick={handleOpenHistory}
                                                    >
                                                        다시 시도
                                                    </button>
                                                </div>
                                            ) : historyList.length === 0 ? (
                                                <div className="h-full flex items-center justify-center text-gray-400">내역이 없습니다.</div>
                                            ) : (
                                                <ul className="space-y-1">
                                                    {historyList.map((item) => (
                                                        <li className="flex justify-between items-center gap-2 p-2 rounded-xl hover:bg-gray-50 border border-transparent hover:border-gray-100">
                                                            <div className="min-w-0">
                                                                <div className="text-xs text-gray-500">{item.createdAt}</div>
                                                                <span className="text-sm font-bold text-gray-700">{item.reason}</span>
                                                            </div>
                                                            <div className={`font-black whitespace-nowrap text-[clamp(0.8125rem,2.2dvh,1.125rem)] ${item.point > 0 ? 'text-blue-600' : 'text-red-500'}`}>
                                                                {item.point > 0 ? '+' : ''}{item.point.toLocaleString()} P
                                                            </div>
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </div>
                                    </div>
                                ) : (
                                    /* 2. 숫자 입력창 — 공용 `PointKeypad` 로 교체 (2026-08-26)
                                       종전 `NumberInput` 은 내부 state + `key` 리마운트로 값을 초기화했는데,
                                       `.popup-number` 4행이 `height:100%` 라 부모 높이가 확정되면 잘렸다.
                                       이제 값은 페이지가 들고(`phoneNumber`/`numbers`), 키패드는 표시만 한다.
                                       ⚠️ 리마운트 초기화가 사라졌으므로 **확인 단계로 넘어가는 모든 지점에서
                                          `setNumbers(initialAmount())` 를 명시적으로 호출**해야 한다(아래 3곳).
                                       🔧 `disabled={amountLocked}` = 고정 포인트 채널의 적립 금액은 설정값으로
                                          고정이라 조작자가 바꿀 수 없다. **전화번호 입력 단계는 영향 없다**
                                          (`amountLocked` 에 `confirmPhoneNumber` 조건이 들어 있다). */
                                    <PointKeypad
                                        leftKey="000"
                                        disabled={amountLocked}
                                        onAppend={(d) => setKeypadValue(keypadValue + d)}
                                        onBackspace={() => setKeypadValue(keypadValue.substring(0, keypadValue.length - 1))}
                                    />
                                )}
                            </div>

                            {/*
                              하단 버튼 = `flex-none` + 높이 하한 2.75rem → 어떤 해상도에서도 가려지지 않는다.

                              🔧 **폭을 1:2 로 나눈다(사용자 요청).** 사용 빈도가 낮은 '포인트 사용'/'이전 단계'는
                                 `basis-1/3`, 빈도가 높은 '포인트 적립'/'적립 완료'는 `flex-1`(=나머지 2/3).
                                 글자 크기도 보조 버튼이 한 단계 작다 — 잘못 누르는 것을 줄이는 것이 목적이다.
                            */}
                            <div className="flex-none flex gap-2 w-full h-[clamp(2.75rem,9dvh,5rem)]">
                                {confirmPhoneNumber ? (
                                    <button
                                        className="basis-1/3 shrink-0 bg-white border-2 border-gray-200 text-gray-600 font-bold rounded-xl hover:bg-gray-50 active:scale-95 transition-all text-[clamp(0.8125rem,2.4dvh,1.125rem)]"
                                        onClick={() => {
                                            setIsHistoryView(false) // [추가] 이전 단계 시 내역창 닫기
                                            setConfirmPhoneNumber(false)
                                            setIsUsing(false)
                                            setNumbers("")
                                            setPhoneNumber("010")
                                            resetToConfiguredMode()   // override 가 다음 고객에게 남지 않게 한다
                                        }}
                                    >
                                        이전 단계
                                    </button>
                                ) : (
                                    <button
                                        className={`basis-1/3 shrink-0 font-bold rounded-xl transition-all active:scale-95 text-white shadow-lg text-[clamp(0.8125rem,2.4dvh,1.125rem)]
                                            ${phoneNumber.length < 9
                                            ? 'bg-gray-300 cursor-not-allowed'
                                            : 'bg-gray-700 hover:bg-gray-800 shadow-gray-200'}`}
                                        disabled={phoneNumber.length < 9}
                                        onClick={() => {
                                            setConfirmPhoneNumber(true)
                                            setNumbers(initialAmount())   // 리마운트 초기화 대체 + 고정 포인트 채널은 설정값 프리필
                                            loadCustomer(formatPhone(phoneNumber))
                                            setIsUsing(true)
                                        }}
                                    >
                                        포인트 사용
                                    </button>
                                )}

                                <button
                                    className={`flex-1 min-w-0 font-bold rounded-xl transition-all active:scale-95 text-white shadow-lg text-[clamp(1rem,3.4dvh,1.75rem)]
                                        ${primaryDisabled
                                        ? 'bg-gray-300 cursor-not-allowed'
                                        : 'bg-blue-600 hover:bg-blue-700 shadow-blue-200'}`}
                                    disabled={primaryDisabled}
                                    onClick={() => {
                                        // [추가] 내역 보기 상태라면 닫아줌
                                        if (isHistoryView) setIsHistoryView(false);

                                        if (confirmPhoneNumber) {
                                            if (isUsing) {
                                                usingPoint(numbers, formatPhone(phoneNumber), selectedEntryPoint.id).then(() => {
                                                    setConfirmPhoneNumber(false)
                                                    setNumbers("")
                                                    setPhoneNumber("010")
                                                    resetToConfiguredMode()   // override 가 다음 고객에게 남지 않게 한다
                                                    setIsUsing(false)
                                                })
                                            } else {
                                                const sales = isRateType ? numbers : null
                                                const point = isRateType ? null : numbers

                                                savePoint(sales, point, formatPhone(phoneNumber), null, selectedEntryPoint.id, false).then(() => {
                                                    setConfirmPhoneNumber(false)
                                                    setNumbers("")
                                                    setPhoneNumber("010")
                                                    resetToConfiguredMode()   // override 가 다음 고객에게 남지 않게 한다
                                                    setIsUsing(false)
                                                    setNotifications(prev => prev.filter(nt => nt !== phoneNumber))
                                                })
                                            }
                                        } else {
                                            setConfirmPhoneNumber(true)
                                            setNumbers(initialAmount())   // 리마운트 초기화 대체 + 고정 포인트 채널은 설정값 프리필
                                            setIsUsing(false)
                                            loadCustomer(formatPhone(phoneNumber))
                                        }
                                    }}
                                >
                                    {confirmPhoneNumber ? (isUsing ? "사용 완료" : "적립 완료") : "포인트 적립"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {/* override 확인 팝업 — `fixed` 라 트리 위치와 무관하지만, 진입점 선택 중에는 띄우지 않는다 */}
            {(selectedEntryPoint && showOverrideConfirm) && renderOverrideConfirm()}
        </div>
    );
};

export default PointViewPage;